import { render } from "./MphPage.vue?vue&type=template&id=4b787208&scoped=true"
import script from "./MphPage.vue?vue&type=script&lang=js"
export * from "./MphPage.vue?vue&type=script&lang=js"

import "./MphPage.vue?vue&type=style&index=0&id=4b787208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b787208"]])

export default __exports__